export default "__VITE_ASSET__Ds6hW00i__"